"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Radio {
    forwardEvent(eventName, originalEvent, el) {
        var _a, _b;
        this.emit(eventName, {
            originalEvent,
            value: (_b = (el || ((_a = this.el) === null || _a === void 0 ? void 0 : _a.querySelector("input")))) === null || _b === void 0 ? void 0 : _b.value,
        }, el);
    }
}
module.exports = Radio;
